import { AbsolutePaths } from "constants/routes";
import { PageNames } from "types-for/routes";

/**
 * Get the URL to navigate to the login page with a redirect url to send the user back after the login.
 * @param redirectUri The URL to redirect to after the login
 * @returns The URL to navigate to the login page with the redirect query parameter
 */
export const getLoginRedirectUrl = (redirectUri?: string): string => {
    return `${AbsolutePaths[PageNames.Login]()}${
        typeof redirectUri === "string" ? `?redirect=${encodeURIComponent(redirectUri)}` : ""
    }`;
};
